<template>
  <div class="quiz-manage">
    <div class="page-header">
      <h2>测验管理</h2>
      <p>管理栏目对应的测验题目，完成栏目所有内容学习后进行答题</p>
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-top: 10px;"
      >
        提示：测验按栏目分组显示，点击行左侧展开图标可查看和管理该栏目的所有题目
      </el-alert>
    </div>

    <el-card class="filter-card">
      <div class="filter-content">
        <div class="filter-left">
          <el-select v-model="filter.categoryId" placeholder="选择栏目" clearable>
            <el-option
              v-for="cat in categories"
              :key="cat.id"
              :label="cat.name"
              :value="cat.id"
            />
          </el-select>
        </div>
        <div class="filter-actions">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd(filter.categoryId)">
            新增测验
          </el-button>
          <el-button type="info" icon="el-icon-refresh" @click="refresh">
            刷新
          </el-button>
        </div>
      </div>
    </el-card>

    <el-card>
      <el-table ref="quizTable" :data="groupedQuizzes" border style="width: 100%" v-loading="loading">
        <el-table-column type="expand" width="60">
          <template slot-scope="props">
            <div class="category-quizzes-detail">
              <div class="quizzes-header">
                <h4>栏目题目列表 (共 {{ props.row.quizzes.length }} 道题)</h4>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  @click="handleAddToCategory(props.row.categoryId)"
                >
                  为该栏目添加题目
                </el-button>
              </div>
              <el-table :data="props.row.quizzes" border size="mini" style="width: 100%">
                <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
                <el-table-column prop="question" label="问题" min-width="200"></el-table-column>
                <el-table-column label="选项" min-width="250">
                  <template slot-scope="scope">
                    <div class="options-list">
                      <div
                        v-for="(option, index) in scope.row.options"
                        :key="index"
                        class="option-item"
                        :class="{ 'correct-option': index === scope.row.correctIndex }"
                      >
                        {{ String.fromCharCode(65 + index) }}. {{ option }}
                        <el-tag
                          v-if="index === scope.row.correctIndex"
                          type="success"
                          size="mini"
                          style="margin-left: 8px;"
                        >
                          正确答案
                        </el-tag>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      @click="handleEdit(scope.row)"
                    >编辑</el-button>
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      size="mini"
                      @click="handleDelete(scope.row.id)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="栏目" min-width="180">
          <template slot-scope="scope">
            <div class="category-info">
              <div class="category-name">{{ scope.row.categoryName }}</div>
              <div class="category-id">ID: {{ scope.row.categoryId }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="题目数量" width="120" align="center">
          <template slot-scope="scope">
            <span class="quiz-count">{{ scope.row.quizzes.length }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="handleManageCategoryQuizzes(scope.row)"
            >管理题目</el-button>
            <el-button
              type="success"
              icon="el-icon-plus"
              size="mini"
              @click="handleAddToCategory(scope.row.categoryId)"
            >添加题目</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="resetForm"
    >
      <el-form
        ref="quizForm"
        :model="formData"
        :rules="formRules"
        label-width="80px"
      >
        <el-form-item label="所属栏目" prop="categoryId">
          <el-select
            v-model="formData.categoryId"
            placeholder="请选择栏目"
            style="width: 100%"
          >
            <el-option
              v-for="cat in categories"
              :key="cat.id"
              :label="cat.name"
              :value="cat.id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="问题" prop="question">
          <el-input
            v-model="formData.question"
            type="textarea"
            :rows="3"
            placeholder="请输入测验问题"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item label="选项A" prop="optionA">
          <el-input
            v-model="formData.optionA"
            placeholder="请输入选项A的内容"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item label="选项B" prop="optionB">
          <el-input
            v-model="formData.optionB"
            placeholder="请输入选项B的内容"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item label="选项C" prop="optionC">
          <el-input
            v-model="formData.optionC"
            placeholder="请输入选项C的内容"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item label="选项D" prop="optionD">
          <el-input
            v-model="formData.optionD"
            placeholder="请输入选项D的内容"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item label="正确答案" prop="correctIndex">
          <el-radio-group v-model="formData.correctIndex">
            <el-radio :label="0">A</el-radio>
            <el-radio :label="1">B</el-radio>
            <el-radio :label="2">C</el-radio>
            <el-radio :label="3">D</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'QuizManagement',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      submitting: false,
      isEdit: false,
      currentId: null,
      filter: {
        categoryId: null
      },
      formData: {
        categoryId: null,
        question: '',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        correctIndex: 0
      },
      formRules: {
        categoryId: [
          { required: true, message: '请选择所属栏目', trigger: 'change' }
        ],
        question: [
          { required: true, message: '请输入问题', trigger: 'blur' }
        ],
        optionA: [
          { required: true, message: '请输入选项A', trigger: 'blur' }
        ],
        optionB: [
          { required: true, message: '请输入选项B', trigger: 'blur' }
        ],
        correctIndex: [
          { required: true, message: '请选择正确答案', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['quizzes', 'categories']),
    groupedQuizzes() {
      const quizzesToGroup = this.filter.categoryId
        ? this.quizzes.filter(q => (q.category_id || q.categoryId) === this.filter.categoryId)
        : this.quizzes

      // 按 categoryId 分组
      const groups = {}
      quizzesToGroup.forEach(quiz => {
        const catId = quiz.category_id || quiz.categoryId
        if (!groups[catId]) {
          const cat = this.categories.find(c => c.id === catId)
          groups[catId] = {
            categoryId: catId,
            categoryName: cat ? cat.name : '未分类',
            quizzes: []
          }
        }
        groups[catId].quizzes.push(quiz)
      })

      return Object.values(groups).sort((a, b) => a.categoryId - b.categoryId)
    },
    dialogTitle() {
      return this.isEdit ? '编辑测验' : '新增测验'
    }
  },
  async created() {
    await this.loadData()
  },
  methods: {
    ...mapActions(['addQuiz', 'updateQuiz', 'deleteQuiz', 'fetchQuizzes']),
    async loadData() {
      this.loading = true
      try {
        await Promise.all([
          this.fetchQuizzes(),
          this.$store.dispatch('fetchCategories')
        ])
      } catch (error) {
        this.$message.error('加载数据失败：' + error.message)
      } finally {
        this.loading = false
      }
    },
    getCategoryName(categoryId) {
      const cat = this.categories.find(c => c.id === categoryId)
      return cat ? cat.name : '未分类'
    },
    async refresh() {
      await this.loadData()
      this.$message.success('刷新成功')
    },
    handleAdd(categoryId = null) {
      this.isEdit = false
      if (categoryId) {
        this.formData.categoryId = categoryId
      }
      this.dialogVisible = true
    },
    handleAddToCategory(categoryId) {
      this.handleAdd(categoryId)
    },
    handleManageCategoryQuizzes() {
      this.$message.info('请点击栏目行左侧的展开图标查看和管理题目')
    },
    handleEdit(row) {
      this.isEdit = true
      this.currentId = row.id
      this.formData = {
        categoryId: row.category_id || row.categoryId,
        question: row.question,
        optionA: row.options[0] || '',
        optionB: row.options[1] || '',
        optionC: row.options[2] || '',
        optionD: row.options[3] || '',
        correctIndex: row.correct_index !== undefined ? row.correct_index : row.correctIndex
      }
      this.dialogVisible = true
    },
    async handleDelete(id) {
      try {
        await this.$confirm('确定要删除这个测验吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        this.deleteQuiz(id)
        this.$message.success('删除成功')
      } catch {
        // 用户取消了删除
      }
    },
    submitForm() {
      this.$refs.quizForm.validate(async valid => {
        if (valid) {
          this.submitting = true
          
          try {
            const quizData = {
              category_id: this.formData.categoryId,
              question: this.formData.question,
              options: [
                this.formData.optionA,
                this.formData.optionB,
                this.formData.optionC || '',
                this.formData.optionD || ''
              ].filter(opt => opt.trim() !== ''),
              correct_index: this.formData.correctIndex
            }
            
            if (this.isEdit) {
              await this.updateQuiz({
                id: this.currentId,
                quiz: quizData
              })
              this.$message.success('更新成功')
            } else {
              await this.addQuiz(quizData)
              this.$message.success('新增成功')
            }
            
            this.dialogVisible = false
            this.resetForm()
          } finally {
            this.submitting = false
          }
        }
      })
    },
    resetForm() {
      if (this.$refs.quizForm) {
        this.$refs.quizForm.resetFields()
      }
      this.isEdit = false
      this.currentId = null
      this.formData = {
        categoryId: null,
        question: '',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        correctIndex: 0
      }
    }
  }
}
</script>

<style scoped>
.quiz-manage {
  padding: 20px;
}
.page-header {
  margin-bottom: 24px;
}
.page-header h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  color: #333;
}
.page-header p {
  margin: 0;
  color: #999;
  font-size: 14px;
}
.filter-card {
  margin-bottom: 20px;
}
.filter-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-left {
  display: flex;
  gap: 10px;
}
.filter-actions {
  display: flex;
  gap: 10px;
}
.options-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.option-item {
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #f5f7fa;
}
.correct-option {
  background-color: #f0f9eb;
  border-left: 3px solid #67c23a;
}
.category-info {
  display: flex;
  flex-direction: column;
}
.category-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}
.category-id {
  font-size: 12px;
  color: #999;
}
.quiz-count {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}
.category-quizzes-detail {
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
}
.quizzes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
}
.quizzes-header h4 {
  margin: 0;
  font-size: 16px;
  color: #333;
}
</style>
